import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core';

import environment from '../../../environments';
import { FileDto } from './../Document.interface';

type Order = 'asc' | 'desc';

interface HeadCell {
  id: keyof FileDto | any;
  label: string;
}

const headCells: HeadCell[] = ([] as HeadCell[]).concat(
  { id: 'name', label: 'Name' },
  environment.fileConfig?.hideTaskKey ? [] : { id: 'id', label: 'ID' },
  environment.fileConfig?.hideInternalDocumentId
    ? []
    : { id: 'internalDocumentId', label: 'Internal ID' },
  environment.fileConfig?.hideVersion
    ? []
    : { id: 'version', label: 'Version' },
  environment.fileConfig?.hideRev ? [] : { id: 'rev', label: 'Rev' },
  { id: 'modifiedBy', label: 'Modified By' },
  { id: 'modified', label: 'Last Modified' },
  { id: 'status', label: 'Status' }
);

interface EnhancedTableProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof FileDto
  ) => void;
  order: Order;
  orderBy: string;
  onSelectAllToggle: any;
  checkboxAllProps: any;
}

function DocumentTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const classes = useStyles();
  const createSortHandler =
    (property: keyof FileDto) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding='checkbox'>
          <Checkbox
            color='primary'
            {...props.checkboxAllProps}
            onChange={(_, checked) => props.onSelectAllToggle(checked)}
          />
        </TableCell>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    }
  })
);

export default DocumentTableHead;
